export const noCof = (selectedCofType, config, finish, receive) => {
  return {
    execFunction: (error, paymentInstrument) => {
      console.log('Error/Result:', error, paymentInstrument);
      receive(error, paymentInstrument);
      finish();
    },
    visualizeFunction: () => {
      return `
function resultCallback(error, paymentInstrument) {
  console.log('Error/Result:', error, paymentInstrument);
}
    `;
    }
  }
};



// WEBPACK FOOTER //
// ./src/bridge/cof/NoCof.js